export default __webpack_public_path__ + "static/media/cartoon-positive-sound.638c6b1b.ogg";